module.exports = __webpack_public_path__ + "img/ktb-logo.a23d0cdc.png";